import { render, staticRenderFns } from "./NewLoginInfo.vue?vue&type=template&id=70f2b029&scoped=true&"
import script from "./NewLoginInfo.vue?vue&type=script&lang=js&"
export * from "./NewLoginInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewLoginInfo.vue?vue&type=style&index=0&id=70f2b029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2b029",
  null
  
)

export default component.exports